import Button from '@admin/components/button'
import Token from '@admin/components/token'
import List from '@admin/components/list'
import PropTypes from 'prop-types'
import Option from './option'
import React from 'react'

class Optionsfield extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.array,
    users: PropTypes.array,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    defaultValue: PropTypes.array,
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    options: []
  }

  _handleAdd = this._handleAdd.bind(this)
  _handleCreate = this._handleCreate.bind(this)

  render() {
    return (
      <>
        <List { ...this._getList() } />
        <Button { ...this._getAdd() } />
      </>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this.setState({
      options: defaultValue
    })
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { options } = this.state
    if(!_.isEqual(options, prevState.options)) {
      this.props.onChange(options)
    }
  }

  _getAdd() {
    return {
      label: '+ t(add option)',
      className: 'link',
      handler: this._handleAdd
    }
  }

  _getEdit(index) {
    const { options } = this.state
    return {
      defaultValue: options[index],
      mode: 'edit',
      options,
      onDone: this._handleUpdate.bind(this, index)
    }
  }

  _getList() {
    const { options } = this.state
    return {
      actions: (item, index) => [
        {
          svg: 'pencil',
          handler: this._handleEdit.bind(this, index)
        },
        {
          svg: 'x',
          confirm: 't(Are you sure you want to remove this option?)',
          handler: this._handleRemove.bind(this, index)
        }
      ],
      items: options,
      empty: <Token text='t(You have not yet added any options)' />,
      format: (option) => (
        <Token>
          <span className="crm-recipientsfield-recipient-extension">
            { option.number }
          </span>
          { option.name }
        </Token>
      )
    }
  }

  _getNew() {
    const { options } = this.state
    return {
      mode: 'new',
      options,
      onDone: this._handleCreate
    }
  }

  _getOption() {
    const { users } = this.props
    return {
      users,
      onDone: this._handleCreate
    }
  }

  _handleAdd() {
    this.context.form.push(Option, this._getNew())
  }

  _handleEdit(index) {
    this.context.form.push(Option, this._getEdit(index))
  }

  _handleCreate(option) {
    this.setState({
      options: [
        ...this.state.options,
        option
      ]
    })
  }

  _handleRemove(index) {
    this.setState({
      options: this.state.options.filter((option, i) => {
        return i !== index
      })
    })
  }

  _handleUpdate(i, updated) {
    this.setState({
      options: this.state.options.map((option, index) => {
        return index === i ? updated : option
      })
    })
  }

}

export default Optionsfield
